import axios from 'axios';
import { call, put, select, all } from 'redux-saga/effects';
import { actions as uiActions } from '@/reducers/ui';
import { API } from '@/config/constants/api';
import { localizeAsset, localizeAssetUrl } from '@/utils/assetPaths';

/* COMMON FOR EVERY WEB */
export const getEntity = data => {
  return (
    axios({
      method: 'POST',
      url: API.FORM.GET_ENTITY_ROWS,
      // withCredentials: true,
      data,
    })
  )
}

export const getTextsFromState = state => state.ui.texts;
export function* getTexts() {
  try {
    const textsOld = yield select(getTextsFromState);
    if (!textsOld) {
      yield call(getParams)
      const reqData = {
        entity: 'textos',
        fieldArray: [
          'idTexto',
          'nombreTexto',
          'contenidoES',
          'contenidoEN',
        ],
      }
      const responseAux = yield call(getEntity, reqData);
      const { data } = responseAux.data;
      yield put(uiActions.setTexts(data));
    }
  } catch (err) {
    yield put(uiActions.setTexts('error'));
  }
}

export const getParamsFromState = state => state.ui.params;
export function* getParams() {
  try {
    const paramsOld = yield select(getParamsFromState);
    if (!paramsOld) {
      const reqData = {
        entity: 'params',
        fieldArray: [
          'idParam',
          'keyName',
          'value',
        ],
      }
      const responseAux = yield call(getEntity, reqData);
      const { data } = responseAux.data;
      yield put(uiActions.setParams(data));
    }
  } catch (err) {
    console.log({err})
    yield put(uiActions.setParams('error'));
  }
}

export const mailFetch = data => (
  axios({
    method: 'POST',
    url: API.USER.SEND_MAIL,
    withCredentials: true,
    data,
  })
)
export function* sendMail({ data }) {
  try {
    const response = yield call(mailFetch, data);
    const { infoOp, operation } = response.data;
    yield put(uiActions.setEmailResult({
      infoOp,
      operation,
    }));
  } catch (err) {
    yield put(uiActions.setEmailResult({
      infoOp: '',
      operation: 'loading',
    }))
  }
}


/* CLIENT THINGS */
export const getBannersFromState = state => state.ui.banners;
export function* getBanners() {
  try {
    const lastBanners = yield select(getBannersFromState);
    if (!lastBanners) {
      const bannerRes = {};
      const allFuckingRequest = [];
      const allDataMapped = {};
      const bannersData = {
        finalName: 'banners',
        entity: 'banner',
        fieldArray: ['idBanner', 'nombreBanner', 'imagen', 'posicionbanner', 'estadobanner', 'link'],
      }
      const imagenData = {
        finalName: 'imagenes',
        entity: 'imagen',
        fieldArray: ['idImagen', 'src', 'width', 'height'],
      }
      const posicionbannerData = {
        finalName: 'posicionBanners',
        entity: 'posicionbanner',
        fieldArray: ['idPosicionBanner', 'nombre'],
      }
      const estadobannerData = {
        finalName: 'estadoBanners',
        entity: 'estadobanner',
        fieldArray: ['idEstadoBanner', 'nombre'],
      }
      allFuckingRequest.push(bannersData);
      allFuckingRequest.push(imagenData);
      allFuckingRequest.push(posicionbannerData);
      allFuckingRequest.push(estadobannerData);
      const allFuckingInfo = yield all(
        allFuckingRequest.map(currentReqData => loopGetEntity(currentReqData))
      );
      // remapping
      allFuckingInfo.forEach((item) => {
        const { data, finalName } = item;
        allDataMapped[finalName] = data;
      })

      const {
        banners,
        imagenes,
        posicionBanners,
        estadoBanners,
      } = allDataMapped;     

      banners.forEach((banner) => {
        const { idBanner, nombreBanner, link, imagen, posicionbanner, estadobanner } = banner;
        const currentImage = imagenes.find(item => item.idImagen == imagen);
        const currentPosition = posicionBanners.find(item => item.idPosicionBanner == posicionbanner);
        const currentState = estadoBanners.find(item => item.idEstadoBanner == estadobanner);
        const newBanner = {
          idBanner,
          nombreBanner,
          imagen: localizeAssetUrl(currentImage && currentImage.src),
          posicionbanner: currentPosition.nombre,
          estadobanner: currentState.nombre,
          link,
        }
        if (!bannerRes[newBanner.posicionbanner]) {
          bannerRes[newBanner.posicionbanner] = [];
        }
        bannerRes[newBanner.posicionbanner].push(newBanner);
      })
      yield put(uiActions.setBanners(bannerRes));
    }
  } catch (err) {
    yield put(uiActions.setBanners(null));
  }
}

function* loopGetEntity(reqData) {
  const { finalName } = reqData;
  const response = yield call(getEntity, reqData);
  return {
    finalName,
    data: response.data.data,
  };
}

export const getActivitiesFromState = state => state.ui.activities;
export function* getActivities() {
  try {
    const activitiesOld = yield select(getActivitiesFromState);
    if (!activitiesOld) {
      const reqData = {
        finalName: 'activitiesAux',
        entity: 'actividades',
        fieldArray: [
          'idActividad',
          'nombreES',
          'nombreEN',
          'enlaceTienda',
          'tituloES',
          'tituloEN',
          'descripcionBreveES',
          'descripcionBreveEN',
          'detalleactividad',
          'imagen',
          'bgimagen',
          'imagenalt',
          'slideimagen',
          'slidesentenceEN',
          'slidesentenceES',
          'seo',
          'orden',
          'tipoActividad',
        ],
      }
      const activitiesResult = [];
      const allFuckingReqData = [];
      const allDataMapped = {}
      // let activitiesAux = yield call(getEntity, reqData);
      // we need resolve index
      const reqData1 = {
        finalName: 'imagenData',
        entity: 'imagen',
        fieldArray: ['idImagen', 'src', 'width', 'height'],
      }
      const reqData2 = {
        finalName: 'slideImagenData',
        entity: 'slideimagen',
        fieldArray: ['idImagen', 'src', 'width', 'height'],
      }
      const reqData3 = {
        finalName: 'bgImagenData',
        entity: 'bgimagen',
        fieldArray: ['idBgImagen', 'src', 'width', 'height'],
      }
      const reqData7 = {
        finalName: 'imagenAltData',
        entity: 'imagenalt',
        fieldArray: ['idImagen', 'src', 'width', 'height'],
      }
      const reqData4 = {
        finalName: 'detalleaActividadData',
        entity: 'detalleactividad',
        fieldArray: ['idda', 'caracteristicaactividad', 'caracteristicaactividadvalor'],
      }
      const reqData5 = {
        finalName: 'caracteristicaActividad',
        entity: ' caracteristicaactividad',
        fieldArray: ['idca', 'nombreES', 'nombreEN'],
      }
      const reqData6 = {
        finalName: 'caracteristicaActividadValue',
        entity: 'caracteristicaactividadvalor',
        fieldArray: ['idcav', 'nombreES', 'nombreEN'],
      }
      const reqData8 = {
        finalName: 'tipoActividadData',
        entity: 'tipoactividad',
        fieldArray: ['idTipoActividad', 'nombreTipoActividad'],
      }
      const reqData9 = {
        finalName: 'agrupadorTarifasData',
        entity: 'agrupadortarifa',
        fieldArray: ['idAT', 'nombreES', 'nombreEN'],
      }
      const reqData12 = {
        finalName: 'grupoTarifasData',
        entity: 'grupotarifa',
        fieldArray: ['idGrupoTarifa', 'nombreES', 'nombreEN'],
      }
      const reqData11 = {
        finalName: 'preciosTarifasData',
        entity: 'preciostarifa',
        fieldArray: ['idPrecio', 'cantidad', 'medidaES', 'medidaEN', 'agrupadortarifa'],
      }
      const reqData10 = {
        finalName: 'tarifasData',
        entity: 'tarifas',
        fieldArray: ['idTarifa', 'actividades', 'nombreTarifaES', 'nombreTarifaEN', 'observacionES', 'observacionEN', 'grupotarifa', 'preciostarifa'],
      }
      /* Probamos la magia */
      allFuckingReqData.push(reqData);
      allFuckingReqData.push(reqData1);
      allFuckingReqData.push(reqData2);
      allFuckingReqData.push(reqData3);
      allFuckingReqData.push(reqData7);
      allFuckingReqData.push(reqData4);
      allFuckingReqData.push(reqData5);
      allFuckingReqData.push(reqData6);
      allFuckingReqData.push(reqData8);
      allFuckingReqData.push(reqData9);
      allFuckingReqData.push(reqData12);
      allFuckingReqData.push(reqData11);
      allFuckingReqData.push(reqData10);

      const allFuckingInfo = yield all(
        allFuckingReqData.map(currentReqData => loopGetEntity(currentReqData))
      );
      // remapping
      allFuckingInfo.forEach((item) => {
        const { data, finalName } = item;
        allDataMapped[finalName] = data;
      })
      const {
        activitiesAux,
        tipoActividadData,
        imagenData,
        slideImagenData,
        bgImagenData,
        imagenAltData,
        agrupadorTarifasData,
        grupoTarifasData,
        preciosTarifasData,
        tarifasData,
        detalleaActividadData,
        caracteristicaActividad,
        caracteristicaActividadValue,
      } = allDataMapped;
      const tarifaRes = {};

      tarifasData.forEach((tarifasItem, index) => {
        const newTarifa = { ...tarifasItem };
        const { actividades, grupotarifa, preciostarifa } = tarifasItem;
        const currentGrupoTarifa = grupoTarifasData.find(itemgt => itemgt.idGrupoTarifa == grupotarifa);
        newTarifa.grupotarifa = currentGrupoTarifa;
        const precios2Fiend = preciostarifa.split(',');
        const precios = precios2Fiend.map((tokkenIdPrecio) => {
          const currentPrecio = preciosTarifasData.find(item => item.idPrecio == tokkenIdPrecio)
          const { agrupadortarifa } = currentPrecio;
          const currentAT = agrupadorTarifasData.find(item => item.idAT == agrupadortarifa);
          currentPrecio.agrupadortarifa = currentAT;
          // debugger;
          return currentPrecio;
        })
        const preciosAgrupados = {};
        precios.forEach((itemPrecio) => {
          const newItemPrecio = { ...itemPrecio }
          const { agrupadortarifa } = itemPrecio;
          const { idAT } = agrupadortarifa;
          delete newItemPrecio.agrupadortarifa;
          if (!preciosAgrupados[idAT]) {
            preciosAgrupados[idAT] = { ...agrupadortarifa };
            preciosAgrupados[idAT].precios = []
          }
          preciosAgrupados[idAT].precios.push(newItemPrecio)
        })
        newTarifa.preciostarifa = preciosAgrupados;
        /* appending process */
        if (!tarifaRes[actividades]) {
          tarifaRes[actividades] = [];
        }
        tarifaRes[actividades].push(newTarifa);
      })
      // console.log('TARIFAS RES:', {tarifaRes});

      /* DETALLE ACTIVIDAD */
      const detallesLibraryRes = [];
      /* building detalles */
      detalleaActividadData.forEach((detalles) => {
        const newDetallesObj = {};
        const { caracteristicaactividad, caracteristicaactividadvalor, idda } = detalles;
        const can = caracteristicaActividad.find(item => item.idca == caracteristicaactividad);
        const canv = caracteristicaActividadValue.find(item => item.idcav == caracteristicaactividadvalor);
        newDetallesObj.idda = idda;
        newDetallesObj.detalleActividad = can;
        newDetallesObj.detalleActividadValue = canv;
        detallesLibraryRes.push(newDetallesObj);
      })
      /* BUILDING DATA */
      activitiesAux.forEach((activity) => {
        const newActivity = { ...activity }
        const {
          idActividad,
          slideimagen,
          imagen,
          bgimagen,
          detalleactividad,
          imagenalt,
          tipoActividad,
        } = activity;
        const currentImageData = imagenData.find(item => item.idImagen == imagen);
        const currentSlideImagenData = slideImagenData.find(item => item.idImagen == slideimagen);
        const currentBgImagenData = bgImagenData.find(item => item.idBgImagen == bgimagen);
        const currentImagenAltData = imagenAltData.find(item => item.idImagen == imagenalt);
        const currentTipoActividad = tipoActividadData.find(item => item.idTipoActividad == tipoActividad)
        newActivity.imagen = localizeAsset(currentImageData);
        newActivity.slideimagen = localizeAsset(currentSlideImagenData);
        newActivity.bgimagen = localizeAsset(currentBgImagenData);
        newActivity.imagenalt = localizeAsset(currentImagenAltData);
        newActivity.tipoActividad = tipoActividad;
        newActivity.tipoactividad = currentTipoActividad ? currentTipoActividad.nombreTipoActividad : '';
        const currentDetalles = [];
        const tokkensda = detalleactividad.split(',');
        tokkensda.forEach((tokken) => {
          const currentDetalle = detallesLibraryRes.find(item => item.idda == tokken);
          currentDetalles.push(currentDetalle)
        })
        newActivity.detallesActividad = currentDetalles;
        /* Tarifas */
        const currentTarifa = (tarifaRes && tarifaRes[idActividad]) || null
        newActivity.tarifas = currentTarifa;
        activitiesResult.push(newActivity);
      })
      const cmpFunction = (itemA, itemB) => (itemA.orden - itemB.orden)
      // before setActivities sortg
      activitiesResult.sort(cmpFunction);
      yield put(uiActions.setActivities(activitiesResult));
    }
  } catch (err) {
    console.log(err)
    yield put(uiActions.setActivities('error'));
  }
}

export const getFaqsFromState = state => state.ui.faqs;
export function* getFaqs() {
  try {
    const reqData = {
      entity: 'faq',
      fieldArray: [
        'idFaq',
        'enunciadoES',
        'enunciadoEN',
        'respuestaES',
        'respuestaEN',
      ],
    }
    const faqsOld = yield select(getFaqsFromState);
    if (!faqsOld) {
      const response = yield call(getEntity, reqData);
      const { data } = response.data;
      yield put(uiActions.setFaqs(data));
    }
  } catch (err) {
    yield put(uiActions.setFaqs('error'));
  }
}
